var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.775 20.479L1.35 3.13a.602.602 0 00-.843.093l-.375.463a.592.592 0 00.093.835L22.65 21.87a.602.602 0 00.843-.093l.375-.463a.59.59 0 00-.093-.835zM11.13 8.434l5.054 3.911c-.083-2.224-1.916-4.002-4.184-4.002-.293 0-.584.031-.87.091zm1.74 8.13l-5.054-3.91c.083 2.223 1.916 4.001 4.184 4.001.293 0 .584-.031.87-.091zM12 7.156c3.7 0 7.09 2.041 8.922 5.344a10.605 10.605 0 01-1.65 2.234l1.415 1.095a12.382 12.382 0 001.984-2.788 1.19 1.19 0 000-1.083C20.636 8.032 16.61 5.375 12 5.375c-1.376 0-2.689.26-3.924.698l1.74 1.347A9.94 9.94 0 0112 7.156zm0 10.688c-3.7 0-7.09-2.041-8.922-5.344a10.6 10.6 0 011.652-2.234L3.315 9.172a12.38 12.38 0 00-1.984 2.787 1.19 1.19 0 000 1.083c2.034 3.926 6.06 6.583 10.669 6.583 1.376 0 2.689-.262 3.924-.698l-1.74-1.346a9.96 9.96 0 01-2.184.263z",
    fill: "#777"
  })));
}

export default SvgEyeHide;